const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class HalfScreenMediaCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)
    this.dragStarted = this.dragStarted.bind(this)
    this.animationEnded = this.animationEnded.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: true,
          },
        },
        slideChanged: this.onSlideChanged,
        dragStarted: this.dragStarted,
        animationEnded: this.animationEnded,
      },
      [setInitialised()],
    )
  }

  onSlideChanged (instance) {
    if (this?.els?.counter?.exists) {
      const currentSlide = instance.track.details.rel
      const matchingSlide = this.els.slide.elements.find(
        (slide, index) => index === currentSlide,
      )

      this.slideColour = matchingSlide?.dataset?.colour
      this.buttonText = matchingSlide?.dataset?.buttonText
      this.buttonTextCta = matchingSlide?.dataset?.buttonTextCta

      this.els.counter.element.classList.remove(
        'sec-HalfScreenMedia_Counter-light',
      )
      this.els.counter.element.classList.remove(
        'sec-HalfScreenMedia_Counter-dark',
      )
      this.els.counter.element.classList.add(
        `sec-HalfScreenMedia_Counter-${this.slideColour}`,
      )

      this.els?.title?.element?.setAttribute(
        'aria-hidden',
        !this.buttonText && !this.buttonTextCta,
      )
    }

    if (this?.els?.index?.exists) {
      this.els.index.element.innerHTML = instance.track.details.rel + 1
    }

    if (this?.els?.title?.exists) {
      this.els.title.element.classList.remove(
        'sec-HalfScreenMedia_Button-light',
      )
      this.els.title.element.classList.remove('sec-HalfScreenMedia_Button-dark')
      this.els.title.element.classList.add(
        `sec-HalfScreenMedia_Button-${this.slideColour}`,
      )
    }

    if (this?.els?.['button-text']?.exists && this.buttonText) {
      this.els['button-text'].element.innerHTML = this.buttonText
    }

    if (this?.els?.['button-text-cta']?.exists && this.buttonTextCta) {
      this.els['button-text-cta'].element.innerHTML = this.buttonTextCta
    }
  }

  dragStarted () {
    this.setAttribute('moving', '')
  }

  animationEnded () {
    this.removeAttribute('moving')
  }
}

if (!customElements.get('half-screen-media-carousel')) {
  customElements.define('half-screen-media-carousel', HalfScreenMediaCarousel)
}
